export class Guide {
    constructor(position, vertical, color, opacity, label) {
        this.label = label,
        this.vertical = vertical, 
        this.position =  position,
        this.color = color || "#000000"
        this.opacity = opacity || 1;
    }
}
